import { render, staticRenderFns } from "./BreakageTransactionHistory.vue?vue&type=template&id=acd9beb6&"
import script from "./BreakageTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./BreakageTransactionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports